// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".library-asset-form .text-box__label--field-name{margin-bottom:16px}", "",{"version":3,"sources":["webpack://./jsapp/js/components/modalForms/libraryAssetForm.scss"],"names":[],"mappings":"AACE,iDACE,kBAAA","sourcesContent":[".library-asset-form {\n  .text-box__label--field-name {\n    margin-bottom: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
